$(document).ready(function () {
  var smoothScrollOffset = window.matchMedia('(max-width: 991.9px)').matches ? -80 : -100;

  if ($.fn.smoothScroll) {
    $('a').smoothScroll({
      offset: smoothScrollOffset,
    });
  }

  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();

    if (scrollTop > 50) {
      $('.fixed_bottom').show();
    } else {
      $('.fixed_bottom').hide();
    }

    if (scrollTop > 1800) {
      $('.bottom-cv').fadeIn();
      $('.bottom-mov').fadeIn();
      $('.bottom-cv-case').fadeIn();
    } else {
      $('.bottom-cv').fadeOut();
      $('.bottom-mov').fadeOut();
      $('.bottom-cv-case').fadeOut();
    }
  });

  $('.bottom-cv-close').on('click', function () {
    $('.bottom-cv').hide().addClass('hide');
  });

  $('.bottom-mov-close').on('click', function () {
    $('.bottom-mov').hide().addClass('hide');
  });

  $('.bottom-cv-case-close').on('click', function () {
    $('.bottom-cv-case').hide().addClass('hide');
  });

  $('.fixed_bottom_close').on('click', function () {
    $('.fixed_bottom').hide().addClass('hide');
  });

  $('.menu-trigger').on('click', function () {
    $(this).toggleClass('active');
    $('.g-nav').slideToggle();
  });

  $('.g-nav ul li a').on('click', function () {
    $('.menu-trigger').toggleClass('active');
    $('.g-nav').slideToggle();
  });

  $('.hover_menu').hover(
    function () {
      $('.hover_menu_back').addClass('is-hover');
    },
    function () {
      $('.hover_menu_back').removeClass('is-hover');
    },
  );
});
